<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "FAQ.TITLE" | translate }}</div>
</mat-toolbar>

<mat-card class="mat-elevation-z0">
    <mat-card-header>
        <mat-card-title>{{ "FAQ.SUBTITLE" | translate }}</mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <mat-accordion multi>
            <mat-expansion-panel class="mat-elevation-z0">
                <mat-expansion-panel-header>
                    <mat-panel-description>{{ "FAQ.PART1" | translate }}</mat-panel-description>
                </mat-expansion-panel-header>

                <div>
                    <p>
                        {{ "FAQ.PART2" | translate }}
                    </p>
                    <p>
                        {{ "FAQ.PART3" | translate }}
                    </p>
                    <p>
                        {{ "FAQ.PART4" | translate }}
                    </p>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="mat-elevation-z0">
                <mat-expansion-panel-header>
                    <mat-panel-description>
                        {{ "FAQ.PART5" | translate }}
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <div>
                    <p>
                        <i>
                            {{ "FAQ.PART6" | translate }}
                        </i>
                    </p>
                    <p>
                        {{ "FAQ.PART7" | translate }}
                    </p>
                    <p>
                        {{ "FAQ.PART8" | translate }}
                    </p>
                    <p>
                        {{ "FAQ.PART9" | translate }}
                    </p>
                    <p>
                        {{ "FAQ.PART10" | translate }}
                    </p>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="mat-elevation-z0">
                <mat-expansion-panel-header>
                    <mat-panel-description>{{ "FAQ.PART11" | translate }}</mat-panel-description>
                </mat-expansion-panel-header>

                <div>
                    <p>
                        <i>
                            {{ "FAQ.PART12" | translate }}
                        </i>
                    </p>
                    <p>
                        {{ "FAQ.PART13" | translate }}
                    </p>
                    <p>
                        {{ "FAQ.PART14" | translate }}
                    </p>
                    <p>
                        {{ "FAQ.PART15" | translate }}
                    </p>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="mat-elevation-z0">
                <mat-expansion-panel-header>
                    <mat-panel-description>
                        {{ "FAQ.PART16" | translate }}
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <div>
                    <p>
                        <i>
                            {{ "FAQ.PART17" | translate }}
                        </i>
                    </p>
                    <p>
                        {{ "FAQ.PART18" | translate }}
                    </p>
                    <p>
                        {{ "FAQ.PART19" | translate }}
                    </p>
                    <p>
                        {{ "FAQ.PART20" | translate }}
                    </p>
                    <p>
                        {{ "FAQ.PART21" | translate }}
                    </p>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="mat-elevation-z0">
                <mat-expansion-panel-header>
                    <mat-panel-description>
                        {{ "FAQ.PART22" | translate }}
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <div>
                    <p>
                        <i>
                            {{ "FAQ.PART23" | translate }}
                        </i>
                    </p>
                    <p>
                        {{ "FAQ.PART24" | translate }}
                    </p>
                    <p>
                        {{ "FAQ.PART25" | translate }}
                    </p>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-card-content>
</mat-card>
